/**
 * Enum for Audit History View Type (i.e., what view invoked the Audit History modal)
 */
export enum AuditHistoryViewType {
  DECKLINE_VIEW = 'decklineViewAudits',
  PAGE_VIEW = 'pageViewAudits',
  DECK_VIEW = 'deckViewAudits',
}

/**
 * Enum for History Item Type (i.e., what type of Audit history item is being generated)
 */
export enum HistoryItemType {
  DECKLINE = 'DecklineHistory',
  PAGE = 'PageHistory',
  DECK = 'DeckHistory',
}

/**
 * Interface for History Item Metadata
 */
export interface HistoryItemMetadata {
  itemId: string;
  itemType: HistoryItemType;
  displayName: string;
}

/**
 * Props for the AuditHistory component.
 * When provided, these override the corresponding useParams() values.
 * Use when rendering AuditHistory inline (not as a routed modal) to avoid
 * depending on URL parameters for the current view type.
 */
export interface AuditHistoryProps {
  /** Override for the :deckId route param */
  deckId?: string;
  /** Override for the :pageName route param */
  pageName?: string;
  /** Override for the :decklineId route param */
  decklineId?: string;
}
